import React, { Component } from 'react';
import { Card, Elevation } from '@blueprintjs/core';

class RegisterForm extends Component {
    render() {
        return (
            <Card
                elevation={Elevation.THREE}
                className="login-card register">
                <div className="login-header">Register</div>
                <div className="login-input">
                    <input className="pt-input pt-fill" placeholder="E-mail" dir="auto" />
                </div>
                <div className="pt-input-group login-input">
                    <input type="password" className="pt-input" placeholder="Enter your password..." />
                    <button className="pt-button pt-minimal pt-intent-warning pt-icon-lock" />
                </div>
                <div className="pt-input-group login-input">
                    <input type="password" className="pt-input" placeholder="Confirm password..." />
                    <button className="pt-button pt-minimal pt-intent-warning pt-icon-lock" />
                </div>
                <div className="login-input flex">
                    <input className="pt-input" placeholder="First Name" dir="auto" />
                    <input className="pt-input" placeholder="Middle Name (Optional)" dir="auto" />
                    <input className="pt-input" placeholder="Last Name" dir="auto" />
                </div>
                <div className="login-input flex">
                    <input className="pt-input" placeholder="Job Title" dir="auto" />
                    <input className="pt-input" placeholder="Phone Number" dir="auto" />
                </div>
                <div onClick={() => this.props.goToRoute('/login')} className="login-new">Already have an account? <span className="register-keyword">Login</span></div>
                <button style={{ marginBottom: '10px' }} disabled type="button" className="pt-button pt-fill pt-intent-primary pt-large">Register</button>
                <span style={{ color: '#0E5A8A' }}><strong>Sorry! Can currently only register by invitation.</strong></span>
            </Card>
        );
    }
}

export default RegisterForm;


// WEBPACK FOOTER //
// ./src/components/authentication/RegisterForm.jsx